module.exports = {"Header":{"Home":"Home","Product Introduce":"Product Introduce","Industries":"Industries","System advantages":"System advantages","About":"About","Downloed":"Downloed","China":"Chinese","English":"English"},"Home":{"About us":"About us","Contact us":"Contact us","Email":"liu@hawk-sight.com","Phone":"135 2871 7233"},"footer":{"Home":"home"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/Language/en.json
// module id = 7vkC
// module chunks = 10